import { FIELD_NAMES } from './constants';

export const emptyDefaultValues = Object.values(FIELD_NAMES).reduce(
  (acc, cur) => ({ ...acc, [cur]: '' }),
  {},
);

export const defaultValues = {
  ...emptyDefaultValues,
  [FIELD_NAMES.specialization]: 'PM',
  [FIELD_NAMES.direction]: 'GMP (top)',
};
